<article class="list-letter-page">
  <header class="list-letter-page__header">
    <h1 class="list-letter-page__title">
      {{ letter }}

      <span *ngIf="page?.split('-')[0]">
        <app-svg-icon class="list-letter-page__title-icon" icon="chevron-down" width="1em"></app-svg-icon>
        {{ page.split('-')[0] }}
      </span>

      <span *ngIf="page?.split('-')[1]">
        <app-svg-icon class="list-letter-page__title-icon" icon="chevron-down" width="1em"></app-svg-icon>
        {{ page.split('-')[1] }}
      </span>
    </h1>
  </header>

  <ul class="list-letter-page__list">
    <li
      *ngFor="let link of list; trackBy: trackByTitle"
      class="list-letter-page__item"
      [class.list-letter-page__item--margin]="jobs"
    >
      <a class="list-letter-page__link" [routerLink]="link.link">
        {{ link.title }}
      </a>
    </li>
  </ul>
</article>
